var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14.1689 14.1689",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.22022 2.06644C2.66072 2.64723 0.75 4.9362 0.75 7.67145C0.75 10.8457 3.32321 13.4189 6.49743 13.4189C9.23268 13.4189 11.5217 11.5082 12.1024 8.94866M8.40508 0.77291C10.9139 1.27875 12.8901 3.25499 13.396 5.7638C13.5354 6.45526 12.9502 7.03285 12.2449 7.03285H8.41324C7.70786 7.03285 7.13603 6.46102 7.13603 5.75564V1.92402C7.13603 1.21864 7.71362 0.633492 8.40508 0.77291Z",
    stroke: "var(--stroke-0, #F79009)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppInsights);
export default __webpack_public_path__ + "static/media/app-insights.bd6657702c43c54f3e0b4e2100e320e2.svg";
export { ForwardRef as ReactComponent };